export default __webpack_public_path__ + "static/media/banner1.a0b4d1a5.jpg";